
import { Vue, Component } from 'vue-property-decorator';
/**
 * 自定义表格配置接口
 */
interface TableConfig {
  headers: string[];
  data: string[][];
  fontSize?: number;
  fontFamily?: string;
  headerBackground?: string;
  headerTextColor?: string;
  cellPadding?: number;
  borderColor?: string;
  borderWidth?: number;
  textAlign?: 'left' | 'center' | 'right';
}
@Component({})
export default class canvasPhotoIndex extends Vue {
  /**
   * 初始化canvas
   * @param tableConfig 表格配置
   */
  initCanvas(tableConfig: TableConfig) {
    // 定义生成文本图片的配置接口
    /**
     * 在Canvas中绘制自定义表格
     * @param canvas Canvas元素
     * @param config 表格配置
     */
    function drawTable(canvas: HTMLCanvasElement, config: TableConfig): void {
      const ctx = canvas.getContext('2d')!;
      const {
        headers,
        data,
        fontSize = 30,
        fontFamily = 'Arial',
        headerBackground = '#fff',
        headerTextColor = '#333',
        cellPadding = 8,
        // borderColor = '#666',
        borderWidth = 1,
        textAlign = 'left',
      } = config;

      // ------------ 计算布局 ------------
      // 1. 设置字体并测量文本宽度
      ctx.font = `${fontSize * 2}px ${fontFamily}`;
      // 然后绘制一个白色矩形覆盖整个画布
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const colWidths: number[] = headers.map((header, colIndex) => {
        // 取表头和数据中最大宽度作为列宽
        const headerWidth = ctx.measureText(header).width;
        const dataWidth = Math.max(...data.map((row) => ctx.measureText(row[colIndex]).width));
        return Math.ceil(Math.max(headerWidth, dataWidth)) + cellPadding * 2;
      });

      // 2. 计算行高
      const rowHeight = fontSize + cellPadding * 2.5;

      // 3. 计算总宽高
      const tableWidth = colWidths.reduce((sum, width) => sum + width, 0);
      const tableHeight = rowHeight * (data.length + 1); // 表头+数据行
      /* eslint-disable no-param-reassign */
      canvas.width = tableWidth + borderWidth * 2;
      canvas.height = tableHeight + borderWidth * 2;
      /* eslint-enable no-param-reassign */

      // ------------ 绘制表格 ------------
      // 1. 绘制表头
      let currentX = borderWidth;
      headers.forEach((header, colIndex) => {
        // 绘制表头背景
        ctx.fillStyle = headerBackground;
        ctx.fillRect(currentX, borderWidth, colWidths[colIndex], rowHeight);

        // 绘制表头文字
        ctx.fillStyle = headerTextColor;
        ctx.font = `${fontSize}px ${fontFamily}`;
        const textX = calculateTextX(currentX, colWidths[colIndex], ctx.measureText(header).width);
        ctx.fillText(header, textX, borderWidth + rowHeight / 2 + fontSize / 3);

        currentX += colWidths[colIndex];
      });

      // 2. 绘制数据行
      let currentY = borderWidth + rowHeight;
      data.forEach((row: any) => {
        let currentINX = borderWidth;
        row.forEach((cell: any, colIndex: number) => {
          // 绘制单元格边框
          // ctx.strokeStyle = borderColor;
          // ctx.lineWidth = borderWidth;
          // ctx.strokeRect(currentINX, currentY, colWidths[colIndex], rowHeight);
          ctx.fillStyle = headerBackground;
          ctx.fillRect(currentINX, currentY, colWidths[colIndex], rowHeight);

          // 绘制单元格文字
          ctx.fillStyle = headerTextColor;
          ctx.font = `${fontSize}px ${fontFamily}`;
          const textX = calculateTextX(currentINX, colWidths[colIndex], ctx.measureText(cell).width);
          ctx.fillText(cell, textX, currentY + rowHeight / 2 + fontSize / 3);

          currentINX += colWidths[colIndex];
        });
        currentY += rowHeight;
      });

      // 根据对齐方式计算文字起始X坐标
      function calculateTextX(startX: number, colWidth: number, textWidth: number): number {
        switch (textAlign) {
          case 'left':
            return startX + cellPadding;
          case 'center':
            return startX + (colWidth - textWidth) / 2;
          case 'right':
            return startX + colWidth - textWidth - cellPadding;
          default:
            return startX + cellPadding;
        }
      }
    }

    // ------------------- 使用示例 -------------------
    // HTML中需有Canvas元素：<canvas id="myCanvas"></canvas>
    const canvas = document.getElementById('myCanvas') as HTMLCanvasElement;
    // 绘制表格
    drawTable(canvas, tableConfig);

    // 导出为图片
    const img = document.createElement('img');
    img.src = canvas.toDataURL('image/png');
    // 插入图片到页面
    const div = document.getElementById('img');
    div?.appendChild(img);
    // console.log(img, 'img');
    // canvas.toBlob((blob) => {
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = 'invoice.png';
    //   link.click();
    //   URL.revokeObjectURL(url); // 释放内存
    // }, 'image/png', 1);
  }
}
